"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactPopper = require("react-popper");

var _CwImage = _interopRequireDefault(require("../cwimage/CwImage"));

var _CwContextMenuItem = _interopRequireDefault(require("./components/CwContextMenuItem"));

var _CwContextMenu = _interopRequireDefault(require("./CwContextMenu.scss"));

var CwContextMenu =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(CwContextMenu, _React$Component);

  function CwContextMenu() {
    var _this;

    (0, _classCallCheck2.default)(this, CwContextMenu);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(CwContextMenu).call(this));
    _this.scrollInterval = null;
    _this.state = {
      activeOption: null,
      containerScrollTop: 0,
      maxMenuHeight: Math.round(window.innerHeight * 0.75),
      menuItemCanvasHeight: 0
    };
    _this.handleWindowResize = _this.handleWindowResize.bind((0, _assertThisInitialized2.default)(_this));
    _this.scrollDown = _this.scrollDown.bind((0, _assertThisInitialized2.default)(_this));
    _this.scrollUp = _this.scrollUp.bind((0, _assertThisInitialized2.default)(_this));
    _this.stopScroll = _this.stopScroll.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(CwContextMenu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateMenuItemCanvasHeight();
      window.addEventListener('resize', this.handleWindowResize);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.updateMenuItemCanvasHeight();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.clearInterval(this.scrollInterval);
      window.removeEventListener('resize', this.handleWindowResize);
    }
  }, {
    key: "updateMenuItemCanvasHeight",
    value: function updateMenuItemCanvasHeight() {
      var menuItemCanvasHeight = this.contextMenuItemCanvas ? this.contextMenuItemCanvas.clientHeight : 0;

      if (this.state.menuItemCanvasHeight !== menuItemCanvasHeight) {
        this.setState({
          menuItemCanvasHeight: menuItemCanvasHeight
        }); // eslint-disable-line
      }
    }
  }, {
    key: "handleWindowResize",
    value: function handleWindowResize() {
      var maxMenuHeight = Math.round(window.innerHeight * 0.75);

      if (this.state.maxMenuHeight !== maxMenuHeight) {
        this.setState({
          maxMenuHeight: maxMenuHeight
        });
      }
    }
  }, {
    key: "scrollDown",
    value: function scrollDown() {
      var _this2 = this;

      this.scrollInterval = window.setInterval(function () {
        var containerScrollTop = _this2.state.containerScrollTop - 1;

        if (containerScrollTop < 0) {
          containerScrollTop = 0;
        }

        _this2.setState({
          containerScrollTop: containerScrollTop
        });
      }, 1);
    }
  }, {
    key: "scrollUp",
    value: function scrollUp() {
      var _this3 = this;

      this.scrollInterval = window.setInterval(function () {
        var maxScrollTop = _this3.state.menuItemCanvasHeight - _this3.state.maxMenuHeight;
        var containerScrollTop = _this3.state.containerScrollTop + 1;

        if (containerScrollTop > maxScrollTop) {
          containerScrollTop = maxScrollTop;
        }

        _this3.setState({
          containerScrollTop: containerScrollTop
        });
      }, 1);
    }
  }, {
    key: "stopScroll",
    value: function stopScroll() {
      window.clearInterval(this.scrollInterval);
      this.scrollInterval = null;
    }
  }, {
    key: "renderContextMenu",
    value: function renderContextMenu() {
      var _this4 = this;

      return _react.default.createElement("div", {
        "data-cwid": this.props.cwId,
        className: (0, _classnames.default)(_CwContextMenu.default.contextMenu, this.props.className),
        style: this.props.style
      }, this.state.menuItemCanvasHeight >= this.state.maxMenuHeight && _react.default.createElement("div", {
        className: _CwContextMenu.default.contextMenuScrollButton,
        onMouseDown: this.scrollDown,
        onMouseUp: this.stopScroll,
        onMouseLeave: this.stopScroll
      }, _react.default.createElement(_CwImage.default, {
        src: this.props.scrollIconDown
      })), _react.default.createElement("div", {
        ref: function ref(c) {
          _this4.contextMenuItemContainer = c;
        },
        className: _CwContextMenu.default.contextMenuItemContainer,
        style: {
          maxHeight: this.state.maxMenuHeight,
          overflow: 'hidden'
        }
      }, _react.default.createElement("div", {
        ref: function ref(c) {
          _this4.contextMenuItemCanvas = c;
        }
      }, this.props.options.map(function (option) {
        return _react.default.createElement(_CwContextMenuItem.default, {
          key: option.id,
          cwId: "".concat(_this4.props.cwId, "_option_").concat(option.id),
          id: option.id,
          isActive: _this4.state.activeOption === option.id,
          childOptions: option.children,
          expandIcon: _this4.props.expandIcon,
          scrollIconDown: _this4.props.scrollIconDown,
          scrollIconUp: _this4.props.scrollIconUp,
          disabled: option.disabled,
          label: option.label,
          seperator: option.seperator,
          onClick: _this4.props.onOptionClick,
          onMouseEnter: function onMouseEnter(o) {
            _this4.setState({
              activeOption: o.id
            });
          }
        });
      }))), this.state.menuItemCanvasHeight >= this.state.maxMenuHeight && _react.default.createElement("div", {
        className: _CwContextMenu.default.contextMenuScrollButton,
        onMouseDown: this.scrollUp,
        onMouseUp: this.stopScroll,
        onMouseLeave: this.stopScroll
      }, _react.default.createElement(_CwImage.default, {
        src: this.props.scrollIconUp
      })));
    }
  }, {
    key: "render",
    value: function render() {
      if (this.contextMenuItemContainer) {
        this.contextMenuItemContainer.scrollTop = this.state.containerScrollTop;
      }

      return _react.default.createElement(_react.Fragment, null, this.props.isSubContextMenu && this.renderContextMenu(), !this.props.isSubContextMenu && _react.default.createElement(_reactPopper.Manager, {
        className: _CwContextMenu.default.contextMenuAnchor,
        style: {
          top: this.props.y,
          left: this.props.x
        }
      }, _react.default.createElement(_reactPopper.Target, null, _react.default.createElement("div", {
        className: _CwContextMenu.default.contextMenuAnchor
      })), _react.default.createElement(_reactPopper.Popper, {
        placement: 'bottom-start'
      }, this.renderContextMenu())));
    }
  }]);
  return CwContextMenu;
}(_react.default.Component);

CwContextMenu.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: _propTypes.default.string,

  /**
   * The css class name to be appended to default classname
   */
  className: _propTypes.default.string,

  /**
   * If this is true, it will not be wrapped in a popper manager
   */
  isSubContextMenu: _propTypes.default.bool,

  /**
   * Icon used for the arrow next to an item that has children
   **/
  expandIcon: _propTypes.default.string,

  /**
   * Icon used for button to scroll the menu down
   **/
  scrollIconDown: _propTypes.default.string,

  /**
   * Icon used for button to scroll the menu up
   **/
  scrollIconUp: _propTypes.default.string,

  /**
   * Override the styles of the root element
   */
  style: _propTypes.default.object,

  /**
   * Array of objects to represent menu options, each should have id and label, children and disabled are optional
   */
  options: _propTypes.default.array,

  /**
   * Fixed x position of context menu
   */
  x: _propTypes.default.number,

  /**
   * Fixed y position of context menu
   */
  y: _propTypes.default.number,

  /**
   * Callback fired when an option is clicked
   */
  onOptionClick: _propTypes.default.func
};
CwContextMenu.defaultProps = {
  cwId: '',
  className: '',
  isSubContextMenu: false,
  expandIcon: '',
  scrollIconDown: '',
  scrollIconUp: '',
  style: {},
  options: [],
  x: 0,
  y: 0,
  onOptionClick: function onOptionClick() {}
};
var _default = CwContextMenu;
exports.default = _default;